import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import FloatingModal from '../components/floatingModal'
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  UncontrolledDropdown,
  Container
} from 'reactstrap'
import { withRouter, Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'
import { AppSidebarNav as AppMenuNav } from '@coreui/react'
import PERMISSION from '../const/userPermission'

import { setStatusAuth } from '../actions/user'
import { getDataBranch, setDefaultStore, clearBranch } from '../actions/branch'
import { getIpirangaPromotionAvailable } from '../actions/ipirangaPromotion'
import { setBackofficeStore } from '../actions/backoffice'
import { checkDocuments } from '../actions/store'
import { localSet, localGet, localRemove } from '../lib/session'
import Config from '../config/environments'
import { logout } from '../service/user'
import rules from './rules'
import ReactGA from 'react-ga'
import SidebarContext from './sidebar/SidebarContext'
import { LEGACY_NAV } from '../config/featureFlags'
import { buildLegacyNavigationStatic } from '../routes/nav'

class DefaultHeader extends Component {
  constructor(props, context) {
    super(props, context)
    this.logoutHandle = this.logoutHandle.bind(this)
    this.state = {
      storeName: '',
      backofficeStore: localGet('BACKOFFICE_STORE'),
      isOpenModal: false
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { props } = this
    const {
      defaultStore: { data: nextDefaultStore }
    } = nextProps
    const {
      defaultStore: { data: prevDefaultStore }
    } = props

    if (nextDefaultStore && nextDefaultStore !== prevDefaultStore) {
      const storeName =
        nextDefaultStore.FantasyName?.length > 25
          ? `${nextDefaultStore.FantasyName.substring(0, 25)}...`
          : nextDefaultStore.FantasyName

      this.setState({ storeName })
      return true
    }

    return false
  }

  shouldComponentUpdate(nextProps, nextState) {
    // CHECK_FEEDBACK ausente/expirado (ex.: reload sem passar pelo login) deve
    // valer false: comparar isOpenModal com null congelava o header inteiro —
    // sem componentDidUpdate, o POST /national-promotion/available nunca era
    // disparado e o item Promoção Ipiranga sumia do menu até novo login.
    const checkFeedback = localGet('CHECK_FEEDBACK') === true
    if (nextProps && nextState && nextState.isOpenModal !== checkFeedback) {
      const { Type } = this.props.authUser.data
      if (Type === 'PORTAL' && checkFeedback) {
        setTimeout(() => {
          this.setState({ isOpenModal: true })
        }, 60000)
      }
      return false
    }
    return true
  }

  logoutHandle(event) {
    event.preventDefault()
    const divChat = document.getElementById('blip-chat-container')
    if (divChat) divChat.remove()
    const p = this.props
    localRemove('CAMPAIN')
    p.clearBranch()
    logout()
    p.setStatusAuth()
    localStorage.removeItem('blipSdkUAccount')
    localStorage.removeItem('AUTH_TOKEN')
  }

  checkOrbitallDocuments(modelBranch) {
    const { props } = this
    let store
    const isCheckDocuments = localGet('CHECK_DOCUMENTS')

    if (modelBranch.length === 1) {
      store = modelBranch[0]
    } else {
      store = modelBranch.filter((e) => e.HeadOffice)[0] || modelBranch[0]
    }
    if (
      !isCheckDocuments &&
      store &&
      !store.IPP &&
      props.authUser.data.Type !== PERMISSION.backoffice
    ) {
      props.checkDocuments(store.Uuid)
      localSet('CHECK_DOCUMENTS', true, Config.EXPIRATION_AUTH)
    }
  }

  componentWillUnmount() {
    this.props.setDefaultStore()
    this.props.setBackofficeStore()
    localRemove('CHECK_FEEDBACK')
  }

  getNavFlags() {
    const { listBranch, defaultStore, authUser } = this.props
    const data = listBranch && listBranch.data
    const freshStoreName = defaultStore?.data?.FantasyName
    if (freshStoreName) this._cachedStoreName = freshStoreName
    const storeName = freshStoreName || this._cachedStoreName || ''
    const isReadonly = authUser?.readOnly || false
    // REV-1872: o item Promoção Ipiranga só aparece quando o back confirma
    // (POST /national-promotion/available) que algum posto participa de
    // campanha Ipiranga ativa; opt-in por filial funciona como trava extra
    const hasPromocaoIpiranga =
      this.props.ipirangaPromotionAvailable &&
      (!process.env.REACT_APP_OPTIN_PROMOCAO_IPIRANGA ||
        (Array.isArray(data) &&
          data.some(
            (b) => b.OptIns && b.OptIns.includes(process.env.REACT_APP_OPTIN_PROMOCAO_IPIRANGA)
          )))

    if (!Array.isArray(data) || data.length === 0) {
      return { hasDesconto: true, hasCashback: true, hasPromocaoIpiranga, isReadonly, storeName }
    }
    return {
      hasDesconto: data.some(
        (b) => b.OptIns && b.OptIns.includes(process.env.REACT_APP_OPTIN_DESCONTO)
      ),
      hasCashback: data.some(
        (b) => b.OptIns && b.OptIns.includes(process.env.REACT_APP_OPTIN_CASHBACK)
      ),
      hasPromocaoIpiranga,
      isReadonly,
      storeName
    }
  }

  componentDidMount() {
    const backofficeBranch = localGet('BACKOFFICE_BRANCH')

    if (backofficeBranch) {
      this.props.getDataBranch(backofficeBranch)
    }
    this.props.authUser.data.Type === 'PORTAL' && this.props.getDataBranch(backofficeBranch)
    this.props.setBackofficeStore(this.state.backofficeStore)
    this.checkIpirangaPromotionAvailability()
    // document.getElementById("requestBot").click()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.listBranch?.data !== this.props.listBranch?.data) {
      this.checkIpirangaPromotionAvailability()
    }
  }

  // REV-1872: consulta o back uma vez por carga de filiais para decidir se o
  // item "Promoção Ipiranga" aparece no menu
  checkIpirangaPromotionAvailability() {
    const data = this.props.listBranch?.data
    if (Array.isArray(data) && data.length > 0) {
      this.props.getIpirangaPromotionAvailable(data.map((b) => b.Uuid))
    }
  }

  render() {
    const buscaParceiro = window.location.pathname === '/busca-parceiro'
    const { storeName, isOpenModal } = this.state
    const { authUser, listBranch, history } = this.props

    if (!authUser) {
      return <Redirect to={{ pathname: '/login' }} />
    }

    const modelBranch = listBranch.data

    this.checkOrbitallDocuments(modelBranch || [])

    const stores = localGet('STORES')
    if (!stores) localSet('STORES', modelBranch, Config.EXPIRATION_AUTH)

    const { location } = history
    const hideHeader = rules[location.pathname]?.hideHeader
    // REV-2085: header do Portal KMV, com a saudação, em todas as telas
    const welcomeStoreName =
      this.props.defaultStore?.data?.FantasyName || listBranch.data?.[0]?.FantasyName

    /*if (isProdURL) {
      children.props.navConfig.items = children.props.navConfig.items.filter(
        (item) => item.name !== "Delivery",
      );
    }*/

    const handleClickCommonQuestions = () => {
      history.push('/perguntas-frequentes')
      ReactGA.event({
        category: 'Header',
        action: 'Perguntas Frequentes usuário autenticado'
      })
    }

    const sidebarCtx = this.context
    const handleToggleSidebar = () => {
      if (sidebarCtx && sidebarCtx.setMobileOpen) {
        sidebarCtx.setMobileOpen((prev) => !prev)
      }
    }

    const legacyNavigation = LEGACY_NAV ? buildLegacyNavigationStatic(this.getNavFlags()) : null

    return (
      <Container>
        {isOpenModal && <FloatingModal />}
        {LEGACY_NAV && (
          <img
            style={{ width: '50px', height: '50px' }}
            src="/assets/imgs/logo_transparent.png"
            alt="KMV"
          />
        )}
        {!LEGACY_NAV && !hideHeader && (
          <button
            type="button"
            className="app-sidebar-toggle"
            onClick={handleToggleSidebar}
            aria-label="Abrir menu"
          >
            <i className="fa fa-bars" />
          </button>
        )}
        {!LEGACY_NAV && (
          <span className="app-header-title">Portal KMV</span>
        )}
        {!LEGACY_NAV && welcomeStoreName && (
          <span id="app-header-welcome" className="app-header-welcome">
            Bem-vindo de volta, <strong>{welcomeStoreName}</strong>
          </span>
        )}
        {LEGACY_NAV && !hideHeader && (
          <Nav className="app-menu ml-auto app-header-menu-dropdown">
            <AppMenuNav
              className="app-header-menu nav-link-custom"
              navConfig={legacyNavigation}
              location={this.props.location}
            />
          </Nav>
        )}
        <Nav navbar className="ml-auto">
          <button
            type="button"
            id="requestBot"
            onClick={handleClickCommonQuestions}
            className="p-0 bg-transparent border-0 "
          >
            <i className="info">
              <img src="/assets/icons/faq-icon.svg" alt="FAQ" />{' '}
            </i>
          </button>
          <UncontrolledDropdown direction="down">
            <DropdownToggle nav>
              <span>
                <i className="cil-user" />
              </span>
            </DropdownToggle>
            <DropdownMenu className="dropdownMenuSite" right style={{ left: 'auto' }}>
              {!!storeName && (
                <DropdownItem className="text-theme-blue-grey" header>
                  {storeName}
                </DropdownItem>
              )}
              {!buscaParceiro && (
                <DropdownItem onClick={() => history.push('/meus-dados')}>Meus dados</DropdownItem>
              )}
              {!buscaParceiro && (
                <DropdownItem onClick={() => history.push('/financeiro')}>Financeiro</DropdownItem>
              )}
              {!buscaParceiro &&
                (authUser?.data?.Type === 'PORTAL' || authUser?.data?.Type === 'BACKOFFICE') && (
                  <DropdownItem onClick={() => history.push('/produtos')}>Produtos</DropdownItem>
                )}
              {!buscaParceiro && authUser.readOnly && (
                <DropdownItem onClick={() => history.push('/busca-parceiro')}>
                  Acessar outra loja
                </DropdownItem>
              )}
              <DropdownItem onClick={this.logoutHandle}>Sair</DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Nav>
      </Container>
    )
  }
}

DefaultHeader.contextType = SidebarContext

DefaultHeader.propTypes = {
  children: PropTypes.shape({}).isRequired,
  history: PropTypes.shape({ push: PropTypes.func }).isRequired,
  setStatusAuth: PropTypes.func.isRequired,
  getDataBranch: PropTypes.func.isRequired,
  checkDocuments: PropTypes.func.isRequired,
  authUser: PropTypes.shape({
    data: PropTypes.object,
    state: PropTypes.bool
  }).isRequired,
  listBranch: PropTypes.shape({
    data: PropTypes.array,
    state: PropTypes.bool
  }).isRequired,
  defaultStore: PropTypes.shape({
    data: PropTypes.array || PropTypes.object,
    state: PropTypes.bool
  }).isRequired
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setStatusAuth,
      getDataBranch,
      setDefaultStore,
      clearBranch,
      checkDocuments,
      setBackofficeStore,
      getIpirangaPromotionAvailable
    },
    dispatch
  )

const mapStateToProps = (state) => ({
  authUser: state.userState.authUser,
  listBranch: state.branchState.listBranch,
  defaultStore: state.branchState.defaultStore,
  ipirangaPromotionAvailable: state.ipirangaPromotionState.available
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DefaultHeader))
